import { useIntl } from 'react-intl';

import { TopBar } from '@xing-com/crate-layout-top-bar';

export const HeaderNavigation: React.FC = () => {
  const { formatMessage } = useIntl();

  return (
    <TopBar
      type="subheader"
      title={formatMessage({ id: 'CAREER_HUB_HOME_TITLE' })}
      hideLoggedOut
    />
  );
};
